module.exports = __webpack_public_path__ + "img/Frame_15.51ff3fa7.png";